import { serializeObject } from "../common/helper";
import { Request } from "./HttpService";

export const TechRoleService = {
  getAll(pageSize, pageNumber, searchObject) {
    let url = `vitae/techrole/${pageSize}/${pageNumber}`;

    url += `?${serializeObject(searchObject)}`;

    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  getAllTechRoles() {
    let url = `vitae/techrole/`;

    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  getById(id) {
    let url = `vitae/techrole/${id}`;

    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  createOrUpdate(techRole) {
    let url = `vitae/techrole/`;

    return Request(url, "POST", techRole).then((data) => {
      return data;
    });
  },
  delete(id) {
    let url = `vitae/techrole/${id}`;

    return Request(url, "DELETE").then((data) => {
      return data;
    });
  }
};
